<template>
  <div class="users-create" v-loading="loader">
    <el-form>
      <el-form-item label="ФИО">
        <el-input v-model="form.name" placeholder=""/>
      </el-form-item>
      <el-form-item label="Табельный номер">
        <el-input v-model="form.personnelNumber" placeholder=""/>
      </el-form-item>
      <el-form-item label="Часовая ставка">
        <el-input v-model="form.hourRate" placeholder=""/>
      </el-form-item>

      <filter-select
        v-model="form.profId"
        label="Профессия"
        onlyValue
        :options="options.profs"
      />

      <el-form-item label="Примечание">
        <el-input v-model="form.comment" placeholder=""/>
      </el-form-item>

      <div v-if="$route.params.userId" style="display: flex; justify-content: space-between">
        <el-button v-if="$route.params.userId" type="danger"
                   @click="deleteObject">Удалить
        </el-button>
        <el-button type="primary" @click="save">Редактировать</el-button>

      </div>
      <div v-else>
        <el-button type="primary" @click="save" style="width: 100%">Сохранить</el-button>

      </div>
    </el-form>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import FilterSelect from '../../../../components/FilterSelect';
import TabelProxy from "../../../../proxy/TabelProxy";
import firebase from "firebase";
import th from "vue2-datepicker/locale/es/th";


export default {
  name: 'UsersCreateCompany',
  components: {FilterSelect, draggable},
  props: ['company'],
  data() {
    return {
      loader: false,
      isOneReport: false,
      options: {
        profs: []
      },
      form: {
        name: "",
        personnelNumber: "",
        profId: "",
        comment: "",
        hourRate: ""
      }
    };
  },
  async mounted() {
    setTimeout(async () => {
      const user = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.$route.params.id).get()

      const user_data = user.data()

      this.isOneReport = user_data.is_one_report_table;
      console.log(this.$store.state.project.id, 'this.$store.state.project.id')

      this.fetchProfs()
      const proxy = new TabelProxy();

      if (this.$route.params.userId) {
        let response = {}

        if (!this.isOneReport) {
          response = await proxy.getUser(this.$route.params.userId)
        } else {
          const user = await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('users')
            .doc(this.$route.params.id)
            .collection('table')
            .doc(this.$route.params.userId)
            .get()


          response = {
            data: user.data()
          }
          console.log(response)
          console.log('---------')
          console.log(user.data(), 'user.data()')
          console.log('---------')
        }

        const {name, personnelNumber, profId, comment, hourRate, _id} = response.data

        this.form = {
          name,
          personnelNumber,
          profId,
          comment,
          hourRate,
          employeeId: _id
        }
      }
    }, 500)
  },

  methods: {
    setName(name) {
      this.form.name = name
    },
    async save() {
      this.loader = true
      const proxy = new TabelProxy();
      if (!this.$route.params.userId) {
        let response = {}
        if (this.isOneReport) {

          const jobs_s_r = await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('users')
            .doc(this.$route.params.id)
            .collection('table')
            .orderBy("index", 'desc').limit(1)
            .get();

          let jobs_s = {
            index: 0
          };

          jobs_s_r.forEach((subDoc) => {
            jobs_s = subDoc.data();
          });


          console.log(jobs_s, "JOOOBS _ L 1");

          response = await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('users')
            .doc(this.$route.params.id)
            .collection('table').add({
              ...this.form,
              companyId: this.company || this.$route.params.id,
              index: jobs_s.index + 1,
            })

          response = {
            status: 'success'
          }
        } else {
          response = await proxy.create(this.$store.state.project.id, {
            ...this.form,
            companyId: this.company || this.$route.params.id
          })
        }


        if (response.status === 'error') {
          this.$notify({
            offset: 60,
            title: 'Ошибка',
            message: 'Заполните все поля',
            type: 'error',
          });
        } else {
          if (!this.company) {
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'Новый работник добавлен',
              type: 'success',
            });

            this.$router.go(-1);
          } else {
            this.$emit('addNewUser', response.data._id)
          }
        }
      } else {

        let response = {}

        if (!this.isOneReport) {
          response = await proxy.update({
            ...this.form,
            companyId: this.company || this.$route.params.id,
            projectId: this.$store.state.project.id
          })
        } else {

          console.log(
            {
              ...this.form,
              companyId: this.company || this.$route.params.id
            }
          )

          delete this.form.employeeId
          response = await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('users')
            .doc(this.$route.params.id)
            .collection('table')
            .doc(this.$route.params.userId)
            .update({
              ...this.form,
              companyId: this.company || this.$route.params.id
            })

          response = {
            status: 'success'
          }
        }

        if (response.status === 'error') {
          this.$notify({
            offset: 60,
            title: 'Ошибка',
            message: 'Заполните все поля',
            type: 'error',
          });
        } else {

          this.$notify({
            offset: 60,
            title: 'Успешно!',
            message: 'Отредактировано',
            type: 'success',
          });

          this.$router.go(-1);
        }
      }
      this.loader = false

    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(async () => {


        if (!this.isOneReport) {
          const proxy = new TabelProxy();

          proxy.remove(this.$route.params.userId)
        } else {
          await firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('users')
            .doc(this.$route.params.id)
            .collection('table')
            .doc(this.$route.params.userId)
            .delete()
        }
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'удалено',
          type: 'success',
        });
        this.$router.go(-1);
      });
    },
    async fetchProfs() {
      const responseProf = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .where('type', '==', 'PROF').get();

      const result = []
      responseProf.forEach((data) => {
        result.push({
          label: data.data().name,
          value: data.id
        })
      })


      console.log('PROOOOFS', responseProf)
      this.options.profs = result;
    },
    getUrl() {
      return ``
    }
  },

  computed: {
    filteredList() {
      return this.jobs.filter((job) => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.users-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/company/UsersCreate.vue